import * as preact from "preact";
import {createContext} from "react";

export type Children = {
    children?: preact.ComponentChildren;
};

export type CSSContext = {
    style?: CSSStyleDeclaration;
    clientWidth?: number;
    clientHeight?: number;
}

export const CSSContext = createContext<CSSContext>({});

export function mergeClasses(arbitrary: string[], other?: string): string {
    return [...arbitrary, ...(other ?? "").split(" ")].join(" ");
}

export type Theme = {
    id: string;
    bodyClass: string;
};

export namespace Theme {
    export const Light: Theme = {
        id: "light",
        bodyClass: ""
    };

    export const Dark: Theme = {
        id: "dark",
        bodyClass: "dark"
    };
};

export const ThemeContext = createContext<Theme>(Theme.Light);

export function getThemeById(id: string): Theme {
    for (const theme of [Theme.Light, Theme.Dark]) {
        if (theme.id == id) {
            return theme;
        }
    }

    throw new Error(`Theme ${id} was not found.`);
}
